import useAccountLibrary from './useActiveWeb3';

export default function useIsConnected() {
  const { account, library } = useAccountLibrary();

  const isConnected = typeof account === 'string' && !!library;

  return isConnected;
}
